import { instance4 } from "App/constants";
import { defaultToastError, today } from "App/utils/helpers";
import moment from "moment";

export const urlGetRole = "/users/listrole";
export const urlGetGudangUtama = "/wmsMasterAsset/gudang/list";
export const urlGetProdusen = "/wmsMasterAsset/master/list-produsen";
export const urlGetSupplier = "/wmsMasterAsset/master/list-supplier";
export const urlGetFiscal = "/wmsassets/master/type_fiscal/listms_type_fiscal";
export const urlGetTipe = "/wmsassets/master/typeassets/listms_type_assets";
export const urlSetType = "/wmsMasterAsset/master/get-typeasset-id";

export const urlGetTingkatAsset =
  "/wmsassets/master/tingkatasset/listms_tingkatasset";
export const urlGetMetodePenyusutan =
  "/wmsassets/master/ms_depreciation_method/listms_depreciation_method";

export const urlGetAsset = "/wmsAsset/asset/list-id";
export const urlAddFixedAsset = "/wmsAsset/asset/add";
export const urlUpdateFixedAsset = "/wmsAsset/asset/update";
export const urlBatalPembelian = "/wmsAsset/asset/cancel";

export const RESET_STATE_INPUT_FIXED_ASSET = {
  id: "",
  name: "",
  code: "",

  no_sn: "",
  no_akd: "",
  no_akl: "",

  merek: "",
  type: "",

  nofaktur: "",
  tgl_pembelian: today(true),
  tgl_pemakaian: today(true),
  tgl_akhirpenyusutan: today(true),
  perkiraan_umur_thn: 0,
  perkiraan_umur_bln: 0,
  nilai_sisaditaksir: 0,
  nilai_aset: 0,
  nilai_sisaditaksir2: 0,
  nilai_aset2: 0,
  status_kelengkapan:0,
  is_asetberwujud: 0,
  is_perhitungansusut: 0,
  is_tahun: 0,

  is_kalibrasi: false,
  tgl_mulai_kalibarasi: moment(new Date()).local().toDate(),
  is_maintenance: false,
  tanggal_maintenance: moment(new Date()).local().toDate(),

  gudang_id: "",
  gudang: "Pilih Gudang",

  produsen_id: "",
  produsen: "Pilih Produsen",

  supplier_id: "",
  supplier: "Pilih Supplier",

  metode_penyusutan_id: "",
  masa_manfaat: 0,
  tarif_penyusutan: 0,

  coa_fixassets_id: null,
  coa_fixassets: "Pilih COA",
  coa_fixassets_code: null,

  coa_akumulasi_id: null,
  coa_akumulasi: "Pilih COA",
  coa_akumulasi_code: null,

  coa_bebanpenyusutan_id: null,
  coa_bebanpenyusutan: "Pilih COA",
  coa_bebanpenyusutan_code: null,

  tingkatasset_id: "",
  remark: "-",
  status: false,
  role_id: "",

  id_fiscal:"",
  nama_fiscal:"Pilih Fiscal",

  type_assets_id:"",
  nama_typeasset:"Pilih Tipe Fixed Asset",

  harga_perolehan: 0,
  harga_perolehan2: 0,

  disabledInput:false,
  unit_id: null,
  nama_unit: 'Pilih Unit',
};

export const validation = (formData) => {
  if (formData.name === "") {
    defaultToastError("Nama tidak boleh kosong!");
    return false;
  }

  return true;
};

export const batalPembelianFA = async (id) => {
  try {
    await instance4.post(urlBatalPembelian, { id });

    return {
      state: true,
      message: "Berhasil melakukan pembatalan pembelian !",
    };
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};